import type { ReactNode } from 'react';
import { ca } from '../i18n/ca';

/**
 * The long part of a step's help, folded under «Com funciona»: a step reads as
 * its controls first, and nothing it used to say is dropped (the owner's
 * review of 2026-10-12). The start step has had the same fold since W4.
 */
export function HowItWorks({ children }: { children: ReactNode }) {
  return (
    <details className="fold">
      <summary className="muted small">{ca.missionUi.intel.howItWorks}</summary>
      {children}
    </details>
  );
}

/**
 * A value the type of mission decides: a lock, the value and the type's own
 * reason. Never a control, and never offered to a vote.
 */
export function FixedValue({
  label,
  value,
  reason,
}: {
  label: string;
  value: ReactNode;
  reason?: string | null;
}) {
  return (
    <p className="fixed-value">
      <i
        className="bi bi-lock"
        role="img"
        aria-label={ca.missionUi.decide.fixedByType}
        title={ca.missionUi.decide.fixedByType}
      />
      <span>
        <strong>{label}</strong> {value}
        {reason && <span className="muted small block">{reason}</span>}
      </span>
    </p>
  );
}
